import { ContractType } from "@/types/facilities";
import type { CurrentContract } from "@/types";
import { CONTRACT_TYPE_LABEL, DAYJS_FORMAT } from "@/constants";
import type { TagLabelType } from "@/components/TagLabel";
import dayjs from "dayjs";

export type FacilityPlan = "none" | "light" | "standard" | "premium";

/** 契約種別 → TagLabel 色（ライト=オレンジ / スタンダード=紫）。 */
export const getContractTypeTagType = (
  type?: ContractType | null,
): TagLabelType => {
  switch (type) {
    case ContractType.LIGHT:
      return "orange";
    case ContractType.STANDARD:
      return "lavender";
    case ContractType.PREMIUM:
      return "brand";
    default:
      return "normal";
  }
};

export const getContractTypeLabel = (
  type?: ContractType | null,
): string | undefined => {
  if (type == null) return undefined;
  return CONTRACT_TYPE_LABEL.find((option) => option.value === type)?.label;
};

/** 契約期間を「開始〜終了」形式で表示する。終了日がなければ「開始〜」。 */
export function formatContractPeriod(contract: {
  start?: string | null;
  end?: string | null;
}): string {
  if (!contract.start) return "-";
  const start = dayjs(contract.start).format(DAYJS_FORMAT.DATE);
  if (!contract.end) return `${start}〜`;
  return `${start}〜${dayjs(contract.end).format(DAYJS_FORMAT.DATE)}`;
}

export const resolveFacilityPlan = (
  contract: CurrentContract | undefined,
): FacilityPlan => {
  if (!contract || !contract.start) return "none";

  const today = dayjs();
  const start = dayjs(contract.start);

  if (today.isBefore(start)) return "none";
  if (contract.end && today.isAfter(dayjs(contract.end).endOf("day"))) return "none";

  switch (contract.type) {
    case ContractType.LIGHT:
      return "light";
    case ContractType.STANDARD:
      return "standard";
    case ContractType.PREMIUM:
      return "premium";
    default:
      return "none";
  }
};

export const isAtLeastLight = (plan: FacilityPlan): boolean => plan !== "none";

export const isAtLeastStandard = (plan: FacilityPlan): boolean =>
  plan === "standard" || plan === "premium";
